// src/components/.../tabs/html.tsx
import React from "react";
import HtmlReset from "@/components/widget/editor/toolbar-buttons/html-reset";
import HtmlSave from "@/components/widget/editor/toolbar-buttons/html-save";



interface Props {
  editorRef: React.RefObject<HTMLElement | HTMLDivElement>;
  htmlDraft: string;
  onSave?: (s: string) => void;
  onReset?: () => void;
}

const HtmlTab: React.FC<Props> = ({ htmlDraft, onSave, onReset }) => {

  return (
    <div className="flex w-full items-center gap-x-3">
      <HtmlSave onSave={() => onSave?.(htmlDraft)} />
      <HtmlReset onReset={() => onReset?.()} />
    </div>
  );
};

export default HtmlTab;
